import React from "react";
import Feature from "../components/Feature";
import Partners from "../components/Partners";
import NewArrival from "../pages/products/NewArrival";
import Herosection from "../components/Herosection";
import Aslider from "../components/Animation.jsx";
import Hero3D from "../components/Hero3D.jsx";
import WatchAndShop from "../components/reels/Reel.jsx";
import Testimonials from "../components/Testimonials.jsx";
import Blog from "../components/Blog.jsx";
import WhyChoos from "../components/WhyChoos";
import Benner from "../components/Benner";

const Home = () => {
  return (
    <>
      <Benner />
      {/* <Herosection /> */}
      <Partners />
      <NewArrival />
      <Aslider />
      {/* <Hero3D /> */}
      <WhyChoos />
      <WatchAndShop />
      {/* <Feature /> */}
      <Testimonials />
      <Blog />
    </>
  );
};

export default Home;
